import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Available roles* :")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_option_group = _resolveComponent("q-option-group")!
  const _component_q_field = _resolveComponent("q-field")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createBlock(_component_q_list, null, {
    default: _withCtx(() => [
      _createVNode(_component_q_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { class: "col-2 text-weight-medium" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_field, {
                "model-value": _ctx.modelValue,
                rules: [_ctx.requiredOptionGroupRule],
                borderless: "",
                "lazy-rules": "",
                "hide-bottom-space": ""
              }, {
                control: _withCtx(() => [
                  _createVNode(_component_q_option_group, {
                    "model-value": _ctx.modelValue,
                    options: _ctx.availableRoles,
                    dense: "",
                    inline: "",
                    outlined: "",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => _ctx.$emit('update:modelValue', value)),
                    "hide-bottom-space": ""
                  }, null, 8, ["model-value", "options"])
                ]),
                _: 1
              }, 8, ["model-value", "rules"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}